const defaultFilters = {
  sort: {
    id: 'sort',
    title: 'Sort by',
    value: 'distance',
    selectValues: [
      { title: 'Date (Asc)', value: 'date' },
      { title: 'Date (Desc)', value: '-date' },
      { title: 'Distance (Asc)', value: 'distance' },
      { title: 'Distance (Desc)', value: '-distance' },
      { title: 'Price (Asc)', value: 'price' },
      { title: 'Price (Desc)', value: '-price' },
    ],
    type: 'selector',
  },
  property_type: {
    id: 'property_type',
    title: 'Type',
    value: '',
    selectValues: [
      { title: 'Please Select...', value: '' },
      { title: 'House', value: 'house' },
      { title: 'Unit', value: 'unit' },
    ],
    type: 'selector',
  },
  radius: {
    id: 'radius',
    title: 'Max Distance from Target Property (km)',
    value: '5',
    type: 'input',
  },
  sold_date: {
    id: 'sold_date',
    title: 'Sold Between',
    value: '',
    valueMax: '',
    type: 'date',
  },
  bedrooms: {
    id: 'bedrooms',
    title: 'Bedrooms',
    value: '',
    valueMax: '',
    comparison: 'eq',
    type: 'comparison',
  },
  bathrooms: {
    id: 'bathrooms',
    title: 'Bathrooms',
    value: '',
    valueMax: '',
    comparison: 'eq',
    type: 'comparison',
  },
  carparks: {
    id: 'carparks',
    title: 'Carparks',
    value: '',
    valueMax: '',
    comparison: 'eq',
    type: 'comparison',
  },
  price: {
    id: 'price',
    title: 'Price',
    value: '',
    valueMax: '',
    comparison: 'bt',
    type: 'comparison',
  },
  area: {
    id: 'area',
    title: 'Area (m2)',
    value: '',
    valueMax: '',
    comparison: 'bt',
    type: 'comparison',
  },
}

export default defaultFilters
